var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-meta"},[(_vm.imgSrc)?_c('img',{staticClass:"lazyload with-shadow meta-image",attrs:{"data-src":_vm.imgSrc},on:{"click":function($event){return _vm.$emit('click-image')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }